import { Provider } from '@angular/core';
import { provideCrossAnalytics } from '@noda-lib/cross-analytics';

export function provideCA(): Provider {
  return provideCrossAnalytics();
}
